export const baseUrl = process.env.PUBLIC_URL;
